import { RESET_BOOKING_STEP_URLS, SAVE_BOOKING_STEP_URL } from "./bookingStepUrlsActionTypes";
import { BookingStepKey } from "../constants/bookingSteps";
import { BookingStepUrlsAction, SaveBookingStepUrlAction } from "./bookingStepUrlsActionCreators";

export type BookingStepUrlsState = {
	urlsByStep: Partial<Record<BookingStepKey, string>>;
};

export const INITIAL_BOOKING_STEP_URLS_STATE: BookingStepUrlsState = {
	urlsByStep: {},
};

export default function bookingStepUrlsReducer(
	state: BookingStepUrlsState = INITIAL_BOOKING_STEP_URLS_STATE,
	action: BookingStepUrlsAction | { type: string }
): BookingStepUrlsState {
	switch (action.type) {
		case SAVE_BOOKING_STEP_URL: {
			const { step, url } = action as SaveBookingStepUrlAction;
			return { ...state, urlsByStep: { ...state.urlsByStep, [step]: url } };
		}
		case RESET_BOOKING_STEP_URLS:
			return INITIAL_BOOKING_STEP_URLS_STATE;
		default:
			return state;
	}
}
